export const MapIntroTitle = `Learning how to use a map`;
export const MapIntroDescription = `Let's give you the tools you'll need to best navigate your map`;
